import qs from 'qs';
import React from 'react';
import { Link } from 'react-router-dom';
import request from '../../../request';

export default class Users extends React.Component {
  constructor({ match }) {
    super();
    this.state = {
      users: JSON.parse(localStorage.getItem('users-' + match.params.id)) || {
        data: [],
      },
    };
  }

  componentDidMount() {
    this.load();
    this.userId = localStorage.getItem('user_id');
  }

  componentDidUpdate(nextProps) {
    if (nextProps.location.search !== this.props.location.search) this.load();
  }

  async load() {
    let { location, match } = this.props;
    let query = qs.parse(location.search.substring(1));
    let page = parseInt(query.page || 1, 10);

    try {
      if (this.state.users.data.length === 0) this.setState({ loading: true });
      let users = await request({
        url: `admin/companies/${match.params.id}/users?page=${page}`,
      });
      localStorage.setItem('users-' + match.params.id, JSON.stringify(users));
      this.setState({ users, loading: false });
    } catch (e) {
      console.error(e);
      this.setState({ loading: false });
    }
  }

  render() {
    let { location, match } = this.props;
    let { users, loading } = this.state;

    let query = qs.parse(location.search.substring(1));
    let page = parseInt(query.page || 1, 10);

    return (
      <div style={{ opacity: loading ? 0.5 : 1 }}>
        <table>
          <thead>
            <tr>
              <th className="last">Last Name</th>
              <th className="first">First Name</th>
              <th className="email">Email</th>
              <th className="status">Status</th>
              <th className="actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.data.map(user => (
              <tr key={user.id}>
                <td className="last">{user.last_name}</td>
                <td className="first">{user.first_name}</td>
                <td className="email">{user.email}</td>
                <td className="status">{user.status}</td>
                <td className="actions">
                  <Link
                    to={
                      parseInt(this.userId, 10) === user.id
                        ? '/settings'
                        : `/settings/companies/user/${user.id}`
                    }
                  >
                    Edit
                  </Link>
                  {' '}
                  ·
                  {' '}
                  <Link
                    to={{
                      pathname: `/settings/users/user/${user.id}/delete`,
                      state: { company_id: match.params.id, user },
                    }}
                  >
                    Delete
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {users.prev_page_url
          ? <Link
              className="prev-button"
              to={
                `/settings/companies/${match.params.id}/users?page=${page - 1}`
              }
            >
              Previous Page
            </Link>
          : null}

        {users.next_page_url
          ? <Link
              className="next-button"
              to={
                `/settings/companies/${match.params.id}/users?page=${page + 1}`
              }
            >
              Next Page
            </Link>
          : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/settings/companies/users.js